<h2 mat-dialog-title>Dados do atendimento</h2>

<mat-dialog-content class="mat-typography">
  <div *ngIf="encounter">
    <div *ngIf="encounter.byOrderInfo.isByOrder == false">
      <b> {{ encounter.type }}:</b> {{ encounter.name ? encounter.name : 'Atendimento' }} <span *ngIf="organization">{{ organization.name }}</span>
      <br />
      <b> Data e Hora:</b> {{ layout.dateTimeFormat(encounter.startDate) }}
    </div>
    <div *ngIf="encounter.byOrderInfo.isByOrder == true">
      <b> {{ encounter.type }}:</b> {{ encounter.name ? encounter.name : 'Atendimento' }} <span *ngIf="organization">{{ organization.name }}</span>
      <br />
      <b> Data e Hora:</b> {{ layout.dateFormat(encounter.startDate) }} - Atendimento por ordem de chegada a partir de
      {{ layout.plannedStartHourFormat(encounter.byOrderInfo.startServiceHour) }}
    </div>
  </div>
  <b> Tipo de agendamento:</b> {{ encounter.scheduling_method }} <br />
  <b> Valor:</b> R$ {{ encounter.value }} <br />
  <b *ngIf="encounter.scheduling_method == 'CONVENIO'"> Valor a ser pago: R$ {{ encounter.value_agreement }}</b> <br />

  <mat-tab-group>
    <mat-tab label="Dados do Paciente">
      <page-data-person *ngIf="patient" [person]="patient"></page-data-person>
      <page-map-view *ngIf="patient?.address" [latLong]="this.latLong" [address]="patient.address"></page-map-view>
    </mat-tab>

    <mat-tab label="Informações Plano de Sáude" *ngIf="encounter.scheduling_method == 'CONVENIO'">
      <div class="info" *ngIf="encounter">
        <div class="row">
          <div class="col-md-4 col-lg-2">Nome do paciente:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.patient_name ?? '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Data de nascimento:</div>
          <div class="col-md-8 col-lg-10">{{ (encounter.health_plan.birth_date | mask: '00/00/0000') || '-' }}</div>
        </div>

        <div class="row">
          <div class="col-md-4 col-lg-2">Convênio:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.health_plan_name }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Modalidade:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.agreement }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Número Cartão:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.card_number }}</div>
        </div>
      </div>
      <page-map-view *ngIf="patient?.address" [latLong]="this.latLong" [address]="patient.address"></page-map-view>
    </mat-tab>

    <mat-tab label="Observação">
      <div class="alerts">
        <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
        <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
      </div>
      <div class="observation-container">
        <p class="observation-label">Informe aqui as observações do atendimento ao paciente:</p>
        <textarea class="observation-textarea" matInput rows="5" [(ngModel)]="encounter.diagnosis" placeholder="Digite a observação aqui"></textarea>
        <button mat-flat-button color="primary" (click)="saveDiagnosis()" [disabled]="isSaving">
          <ng-container *ngIf="!isSaving">Salvar alterações</ng-container>
          <ng-container *ngIf="isSaving">
            <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
          </ng-container>
        </button>
      </div>
    </mat-tab>

    <mat-tab *ngIf="encounter.status == 'planned'" label="Reagendamento">
      <div class="row rowTime">
        <div class="col-xs-12 col-sm-6 col-md-4">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Escolha a data</mat-label>
            <input
              matInput
              [matDatepickerFilter]="dateFilter"
              [matDatepicker]="picker"
              [(ngModel)]="hour.date"
              readonly
              (dateChange)="onDateChange($event)"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3" *ngIf="!isByOrder">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Horários disponíveis</mat-label>
            <mat-select [(value)]="hour.time">
              <mat-option
                *ngFor="let item of hours"
                [value]="item.timeStart"
                [disabled]="(disabledTimes && disabledTimes.includes(item.timeStart)) || hours.length == 0 || disabledMinuts(item.timeStart)"
              >
                {{ item.timeStart }} - {{ item.timeEnd }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4">
          <button mat-flat-button color="primary" (click)="reagendamento()" [disabled]="loading" class="btReagendar">Reagendar</button>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Receita" *ngIf="encounter.status == 'finished'">
      <page-create-prescription [encounter_id]="encounter.encounter_id" [patient_id]="encounter.patient.patient_id"></page-create-prescription>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>

  <button mat-flat-button color="warn" class="btnCancelar" *ngIf="encounter.status != 'finished'" cdkFocusInitial (click)="cancelSchedule()">
    Cancelar atendimento
  </button>
</mat-dialog-actions>
